// "可视/非可视" 组件通用 API
import jsBridge from "../../common/jsBridge";

export function destroyComponent({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/destroyComponent', params})
}

export function getComponentOptions({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/getComponentOptions', params})
}

export function closeAd({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    return jsBridge.callNative({fnName: 'VideoBridge/closeAd', params})
}